module.exports = __webpack_public_path__ + "static/img/qd_type2.8f4c02c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/qd_type2.png
// module id = SbPH
// module chunks = 167